import {Page} from '../../layout/components';
import React from 'react';

export default function NotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="text">Sorry, we couldn't find that!</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/features/shared/components/NotFoundPage.js